import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const translations = {
    fr: {
      'loading': 'Chargement...',

      // Admin Navigation
      'Dashboard': 'Tableau de bord',
      'Testimonials': 'Témoignages Vidéo',
      'Messages': 'Messages',
      'Services': 'Services',
      'Portfolio': 'Portfolio',
      'Clients': 'Clients',
      'Quotes': 'Devis',
      'Invoices': 'Factures',
      'admin.logout': 'Déconnexion',

      // Admin Login
      'admin.login.title': 'Connexion Admin',
      'admin.login.desc': 'Connectez-vous pour accéder au tableau de bord',
      'admin.login.email': 'Adresse e-mail',
      'admin.login.password': 'Mot de passe',
      'admin.login.btn': 'Se connecter',
      'admin.login.signingIn': 'Connexion en cours...',
      'admin.dashboard': 'Tableau de bord',
    },
    en: {
      'loading': 'Loading...',

      // Admin Navigation
      'Dashboard': 'Dashboard',
      'Testimonials': 'Video Testimonials',
      'Messages': 'Messages',
      'Services': 'Services',
      'Portfolio': 'Portfolio',
      'Clients': 'Clients',
      'Quotes': 'Quotes',
      'Invoices': 'Invoices',
      'admin.logout': 'Sign Out',

      // Admin Login
      'admin.login.title': 'Admin Login',
      'admin.login.desc': 'Sign in to access the dashboard',
      'admin.login.email': 'Email address',
      'admin.login.password': 'Password',
      'admin.login.btn': 'Sign In',
      'admin.login.signingIn': 'Signing in...',
      'admin.dashboard': 'Dashboard',
    }
  };

  const t = (key) => translations[language]?.[key] || translations['fr']?.[key] || key;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);